import Cookies from 'js-cookie'

export function getToken(token) {
  return Cookies.get(token)
}
export function setToken(key,token) {
  return Cookies.set(key, token)
}
export function removeToken(key) {
        Cookies.remove(key)
}
export function Cookieclear() {
  Cookies.clear()
}
export function GetStorage(value){
  return localStorage.getItem(value)
}
export function SetStorage(key,value){
   localStorage.setItem(key,value)
}
export function removeStorage(key){
   localStorage.removeItem(key)
}
export function localStorageClear(key){
   localStorage.clear()
}
// 防止本地存储命名冲突 
const config={
  namespace:'shennanyin'
}
export default {
  setItem(key, val) {
    let storage = this.getStroage();
    storage[key] = val;
    window.localStorage.setItem(config.namespace, JSON.stringify(storage));
  },
  getItem(key) {
    return this.getStroage()[key];
  },
  getStroage() {
    return JSON.parse(window.localStorage.getItem(config.namespace) || "{}");
  },
  clearItem(key) {
    let storage = this.getStroage();
    delete storage[key];
    window.localStorage.setItem(config.namespace, JSON.stringify(storage));
  },
  clearAll() {
    window.localStorage.clear();
  },
};
